import { Check, ArrowRight, Mail, Shield, Users } from "lucide-react";
import { Button } from "../Pages/ui/button"
import { Card, CardContent } from "../Pages/ui/card";
import { Link, useLocation } from "react-router-dom";

const RegistrationSuccessfullPage = () => {
  const location = useLocation();
  const email = location.state.email;
  return (
    <div className="min-vh-100 bg-light">
      {/* Success Container */}
      <div className="d-flex align-items-center justify-content-center min-vh-100 p-4">
        <div className="w-100" style={{ maxWidth: "782px" }}>
          {/* Success Icon */}
          <div className="text-center mb-5">
            <div className="position-relative d-inline-flex align-items-center justify-content-center">
              <div
                className="position-absolute top-0 start-0 w-100 h-100 bg-success rounded-circle"
                style={{
                  animation: "pulse 2s infinite",
                  opacity: 0.2,
                }}
              ></div>
              <div className="position-relative bg-success rounded-circle p-4 shadow-lg">
                <Check className="text-white" size={48} strokeWidth={3} />
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="text-center mb-5">
            <h1 className="display-4 fw-bold text-dark">
              Registration
              <span className="d-block text-success">Successful!</span>
            </h1>

            <p
              className="fs-5 text-secondary mx-auto"
              style={{ maxWidth: "500px" }}
            >
              We have sent a verification email to your registered email address. Please check your inbox at {email} to activate your account.
            </p>
          </div>

          {/* Features Grid */}
          <div className="row g-4 mb-5">
            <div className="col-md-4">
              <Card className="border-0 shadow-sm h-100">
                <CardContent className="p-4 text-center">
                  <div
                    className="bg-primary bg-opacity-10 rounded-circle p-3 mx-auto mb-3"
                    style={{ width: "fit-content" }}
                  >
                    <Mail className="text-primary" size={24} />
                  </div>
                  <h3 className="fw-semibold text-dark mb-2">Email Verified</h3>
                  <p className="text-muted small">
                    Your email address has been confirmed and verified.
                  </p>
                </CardContent>
              </Card>
            </div>

            <div className="col-md-4">
              <Card className="border-0 shadow-sm h-100">
                <CardContent className="p-4 text-center">
                  <div
                    className="bg-opacity-10 rounded-circle p-3 mx-auto mb-3"
                    style={{ width: "fit-content", background: "#efe1fe" }}
                  >
                    <Shield className="text-primary outline-info" size={24} />
                  </div>
                  <h3 className="fw-semibold text-dark mb-2">
                    Account Secured
                  </h3>
                  <p className="text-muted small">
                    Your account is protected with industry-standard security.
                  </p>
                </CardContent>
              </Card>
            </div>

            <div className="col-md-4">
              <Card className="border-0 shadow-sm h-100">
                <CardContent className="p-4 text-center">
                  <div
                    className="bg-success bg-opacity-10 rounded-circle p-3 mx-auto mb-3"
                    style={{ width: "fit-content" }}
                  >
                    <Users className="text-success" size={24} />
                  </div>
                  <h3 className="fw-semibold text-dark mb-2">
                    Community Access
                  </h3>
                  <p className="text-muted small">
                    You now have full access to our platform and community.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center align-items-center">
            {/* <a href="https://mail.google.com/mail" target="blank"> */}
            <Link to={"/login"}>
              <Button
                size="lg"
                className="btn btn-default px-5 py-3 fw-medium shadow"
                style={{ transition: "all 0.2s" }}
              >
                Login PugCRM
                <ArrowRight className="ms-2" size={20} />
              </Button>
              {/* </a> */}
            </Link>
          </div>

          {/* Additional Info */}
          <div className="text-center mt-5 pt-4 border-top">
            <p className="text-muted small mb-3">Need help getting started?</p>
            <div className="d-flex flex-wrap justify-content-center gap-3 small">
              <a
                href="#"
                className="text-primary fw-medium text-decoration-none"
              >
                View Tutorial
              </a>
              <a
                href="#"
                className="text-primary fw-medium text-decoration-none"
              >
                Contact Support
              </a>
              <a
                href="#"
                className="text-primary fw-medium text-decoration-none"
              >
                Documentation
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Simple pulse animation CSS */}
      <style>{`
        @keyframes pulse {
          0% {
            transform: scale(1);
            opacity: 0.2;
          }
          50% {
            transform: scale(1.5);
            opacity: 0;
          }
          100% {
            transform: scale(1);
            opacity: 0.2;
          }
        }
      `}</style>
    </div>
  );
};

export default RegistrationSuccessfullPage;